'use client'

import { GoogleAnalytics } from '@next/third-parties/google'
import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'
import {
  TAEKWONDO_GA_ID,
  getTaekwondoSurface,
  sendTaekwondoEvent,
  setTaekwondoAnalyticsReady,
} from '@/lib/analytics/taekwondo'

/**
 * 태권낭자 화면에서만 별도 GA4 속성을 로드합니다.
 * 기존 공용 GA4 속성은 그대로 유지되며, 태권낭자 전용 데이터와 섞이지 않습니다.
 */
export function TaekwondoAnalytics() {
  const pathname = usePathname()
  const surface = getTaekwondoSurface(pathname || '')
  const lastTrackedPathRef = useRef<string | null>(null)

  useEffect(() => {
    if (!surface || !pathname || lastTrackedPathRef.current === pathname) return

    // GoogleAnalytics 컴포넌트의 config 호출 이후 전송되도록 짧게 지연합니다.
    const timer = window.setTimeout(() => {
      setTaekwondoAnalyticsReady(true)
      if (sendTaekwondoEvent('avatar_experience_view', { surface, page_path: pathname })) {
        lastTrackedPathRef.current = pathname
      }
    }, 800)

    return () => {
      window.clearTimeout(timer)
      setTaekwondoAnalyticsReady(false)
    }
  }, [pathname, surface])

  if (!TAEKWONDO_GA_ID || !surface) return null

  return <GoogleAnalytics gaId={TAEKWONDO_GA_ID} />
}
